export default __webpack_public_path__ + "static/project-b545fb2c3b17b7a7636f7246e980cf87.jpg";